module.exports = __webpack_public_path__ + "static/media/10.6ddaaf00.svg";